import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const getClergyBioPersonInfo = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/personal.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioPersonInfo = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/personal.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};


export const getClergyBioChurchReport = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/church_reporting.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioChurchReport = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/church_reporting.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getClergyBioRelationships = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/relationships.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioRelationships = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/relationships.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getClergyBioEducation = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/educations.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioEducation = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/educations.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getClergyBioMinistry = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/ministries.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioMinistry = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/ministries.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getClergyBioVolunteer = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/volunteer_positions.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioVolunteer = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/volunteer_positions.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};

export const getClergyBioProfessional = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/professionals.json`,
		onSuccess,
		onFailure,
	});
};

export const patchClergyBioProfessional = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/professionals.json`,
		onSuccess,
		onFailure,
		payloadData,
	});
};


export const getClergyBioEcclesiastics = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/profiles/${guid}/ecclesiastics.json`,
		onSuccess,
		onFailure,
	});
};


export const getClergyBioInstitutions = (values: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.clergyBioApi}/organizations/search_employers.json?val=${values}`,
		onSuccess,
		onFailure,
	});
};
